/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { useEffect, useState } from 'react';
import PortfolioPrintView from './PortfolioPrintView';

// PortfolioPrintView is `print:block hidden` — invisible to users but still
// renders ~150 elements (every project/section item) into the DOM, which
// Lighthouse counts toward its "Optimize DOM size" budget. Defer mounting
// until the browser fires `beforeprint` so the initial DOM stays lean while
// Ctrl+P still produces the full resume layout.
export default function LazyPortfolioPrintView({
  profile,
  sections,
}: {
  profile: any;
  sections: any[];
}) {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Some browsers fire `beforeprint`, others rely on the print-media
    // matchMedia change event. Wire up both so we mount in time for the
    // print preview either way.
    const handler = () => setShouldRender(true);
    window.addEventListener('beforeprint', handler);
    const mql = window.matchMedia('print');
    mql.addEventListener?.('change', handler);
    return () => {
      window.removeEventListener('beforeprint', handler);
      mql.removeEventListener?.('change', handler);
    };
  }, []);

  if (!shouldRender) return null;
  return <PortfolioPrintView profile={profile} sections={sections} />;
}
